import { useNavigate, useLocation } from "react-router-dom";
import { CraneMark } from "@/components/CraneMark";
import { Editable } from "@/components/Editable";
import { useAuth } from "@/contexts/AuthContext";
import { CMS } from "@/constants/testIds/cms";

export function Footer({ onAdminClick }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { admin } = useAuth();

  function scrollToId(id) {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 80);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  }

  return (
    <footer>
      <div className="wrap">
        <div className="disclaimer-bar">
          <span className="disclaimer-label" data-testid={CMS.disclaimerLabel}>
            Educational purposes only — not medical advice
          </span>
          <Editable path="disclaimer.text" tag="p" className="disclaimer-text" testId={CMS.disclaimerText} />
        </div>
        <div className="footer-inner">
          <div className="footer-brand">
            <CraneMark viewBox="150 60 170 120" />
            <span>Elegant Crane Health</span>
          </div>
          <nav>
            <ul style={{ display: "flex", listStyle: "none" }}>
              <li>
                <a onClick={() => scrollToId("modalities")}>Practices</a>
              </li>
              <li>
                <a onClick={() => navigate("/videos")}>Videos</a>
              </li>
              <li>
                <a onClick={() => scrollToId("about")}>About</a>
              </li>
              <li>
                <a className="nav-admin" onClick={onAdminClick} data-testid={CMS.footerAdmin}>
                  {admin ? "Admin panel" : "Site admin"}
                </a>
              </li>
            </ul>
          </nav>
          <Editable path="footer.tagline" tag="span" className="fine" />
        </div>
      </div>
    </footer>
  );
}
